import { medtechApi } from '.';
import { Group } from '../types';

export const groupsApi = {
  fetchGroups: () => {
    return medtechApi.get<Group[]>('groups').then(({ data }) => data);
  },
};
